import ErrorDialog from './Variants/ErrorDialog';
import InfoDialog from './Variants/InfoDialog';
import SuccessDialog from './Variants/SuccessDialog';

export const DIALOGS = {
  info: InfoDialog,
  error: ErrorDialog,
  success: SuccessDialog,
};
